export const PLUGIN_PACKAGE = 'org.graylog.aws';
export const PLUGIN_CONFIG_CLASS_NAME = `${PLUGIN_PACKAGE}.config.AWSPluginConfiguration`;
export const PLUGIN_API_ENDPOINT = `/plugins/${PLUGIN_PACKAGE}/config`;
